/** @jsxImportSource @emotion/react */
import { Card } from "primereact/card";
import Titulo from "../titulo";
import { urlBaseAPI } from "../../utils";

/**
 * Card "Certificado acreditado" para las plataformas de cliente y pública.
 *
 * Recibe los vínculos vigentes de la norma con sus acreditaciones
 * (Norma_x_Acreditacion con `acreditacion: {organismoAcreditacion, pais,
 * linkAlcance, marcaArchivo: {hash}}`). Por cada acreditación indica quién
 * acreditó y muestra la marca; la imagen (con el subtexto "Ver alcance aquí")
 * abre el link al alcance en una pestaña nueva. Sin vínculos no renderiza nada.
 *
 * Con `sinCard` renderiza solo la información, sin la Card ni el título, para
 * embeberla en una card existente (ej. el resultado del buscador público).
 */
export default function CardCertificadoAcreditado({ vinculos, sinCard }) {
  if (!vinculos?.length) return null;

  const contenido = (
    <>
      {vinculos.map((vinculo) => (
        <div key={vinculo.id} css={{ marginBottom: "1.5em" }}>
          <p>
            Acreditado por{" "}
            <strong>{vinculo.acreditacion?.organismoAcreditacion}</strong>
            {vinculo.acreditacion?.pais && ` de ${vinculo.acreditacion.pais}`}
          </p>
          {vinculo.acreditacion?.marcaArchivo?.hash && (
            <a
              href={vinculo.acreditacion.linkAlcance || undefined}
              target="_blank"
              rel="noreferrer"
              css={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "0.5em",
                textDecoration: "none",
                cursor: vinculo.acreditacion.linkAlcance
                  ? "pointer"
                  : "default"
              }}
            >
              <img
                src={`${urlBaseAPI()}/archivo/${vinculo.acreditacion.marcaArchivo.hash}/preview`}
                alt={`Marca de acreditación de ${vinculo.acreditacion.organismoAcreditacion}`}
                css={{ maxWidth: "150px" }}
              />
              {vinculo.acreditacion.linkAlcance && (
                <small css={{ color: "var(--principal)" }}>
                  Ver alcance aquí
                </small>
              )}
            </a>
          )}
        </div>
      ))}
    </>
  );

  if (sinCard) {
    return contenido;
  }

  return (
    <Card>
      <Titulo>Certificado acreditado</Titulo>
      {contenido}
    </Card>
  );
}
